import styled from "styled-components";

export const Container = styled.div``;
export const Content = styled.div``;
export const AreaShowMore = styled.div``;
export const ButtonShowMore = styled.button`
	border: none;
	background: none;
	margin: 0.4rem 1rem;

	> span {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
`;
